/* eslint-disable react/prop-types */
import { useContext, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import Swal from "sweetalert2";
import "./styles.css";
import { toast } from "react-toastify";
import { Context } from "../../../../../hooks/useAuthContext";
import api from "../../../../../services/axiosConfig";

function ModalCancelNF({ isOpen, toggle, nfId, onSuccess  }) {
  const { exibirLogs } = useContext(Context);
  const [cancelReason, setCancelReason] = useState("");
  const [isReasonInvalid, setIsReasonInvalid] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (motivo) => {
    if (cancelReason.trim() === "") {
      setIsReasonInvalid(true);
      Swal.fire({
        icon: "warning",
        title: "Motivo Obrigatório",
        text: "Por favor, insira um motivo para o cancelamento da nota fiscal.",
      });
      return;
    }

    setLoading(true);
    try {
      await api.patch(`/nf/cancelar-nota/${nfId}`, {
        status: "cancelado",
        motivoCancelamento: motivo,
      });
      toast.success("Nota fiscal cancelada com sucesso!");
      onSuccess();
      toggle();
      return true;
    } catch (error) {
      exibirLogs && console.error("Erro ao cancelar a nota fiscal:", error);
      toast.error("Erro ao cancelar nota");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Cancelar Nota Fiscal</ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="cancelReason">
              Motivo do cancelamento <span className="text-danger">*</span>
            </Label>
            <Input
              type="textarea"
              name="cancelReason"
              id="cancelReason"
              rows="4"
              value={cancelReason}
              onChange={(e) => setCancelReason(e.target.value)}
              placeholder="Ex: Nota fiscal emitida incorretamente, serviço cancelado, etc."
              required
              invalid={isReasonInvalid}
            />
            {isReasonInvalid && (
              <div className="invalid-feedback d-block">
                O motivo do cancelamento é obrigatório.
              </div>
            )}
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          color="danger"
          onClick={() => handleSubmit(cancelReason)}
          disabled={loading}
        >
          {loading ? "Cancelando..." : "Confirmar Cancelamento"}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ModalCancelNF;
